import { render, staticRenderFns } from "./ReferenciaMedica.vue?vue&type=template&id=a2a0917e"
import script from "./ReferenciaMedica.vue?vue&type=script&lang=js"
export * from "./ReferenciaMedica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports